import { BatterSessionReportChartConfigDto, BatterSessionStatsByPitchTypeChartDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof BatterSessionStatsByPitchTypeChartDto)[] = ['pitchType'];

const BatterSessionStatsByPitchTypeChartSidebar = (props: ChartConfigProps<TableChartConfigDto, BatterSessionReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='BatterSessionStatsByPitchTypeChart'
      chartKey='batterSessionStatsByPitchTypeChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default BatterSessionStatsByPitchTypeChartSidebar;
